import React from 'react'
import './styles.css'

export default ({stage}) => {
  return (
    <div className='stagedetails'>
      <div><span className='label'>Stage Nr: </span><span className='value'>{stage.stageId}</span></div>
      <div><span className='label'>Country: </span><span className='value'>{(stage.country || ['-']).join(', ')}</span></div>
      <div><span className='label'>Start Date: </span><span className='value'>{stage.startDate}</span></div>
      <div><span className='label'>Start Coordinates: </span><span className='value'>{stage.startPos}</span></div>
      <div><span className='label'>Start City: </span><span className='value'>{stage.startCity}</span></div>
      <div><span className='label'>Finish Coordinates: </span><span className='value'>{stage.stopPos}</span></div>
      <div><span className='label'>Finish City: </span><span className='value'>{stage.stopCity}</span></div>
      <div><span className='label'>Highlights: </span><span className='value'>{(stage.highlights || ['-']).join(', ')}</span></div>
      <div><span className='label'>Surface: </span><span className='value'>{(stage.surface || ['-']).join(', ')}</span></div>
    </div>
  )
}